'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _options = require('./options');

var _options2 = _interopRequireDefault(_options);

var _initialize = require('../core/initialize');

require('./api');

require('./buttons');

require('./templates');

require('./editor');

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jquery2.default.fn.dataTableExt.sErrMode = 'throw'; // replace alerts with console errors

var log = (0, _debug2.default)('linksoft:datatables:create');

// support for externalized data-table actions
(0, _jquery2.default)(document).on('click', '[data-table-action]', function () {
	var $self = (0, _jquery2.default)(this);
	var actionName = $self.attr('data-table-action');
	var $target = (0, _jquery2.default)($self.attr('data-target'));
	if ($target.length === 0) $target = $self.closest('[data-table]');
	if ($target.length === 0) return;
	var tableApi = $target.DataTable();
	switch (actionName) {
		case 'clearFilters':
			tableApi.clearFilters();
			break;
		case 'reload':
			tableApi.ajax.reload(null, false);
			break;
	}
	return false;
});

(0, _jquery2.default)(document).on('click', '.dataTable [data-table-delete]', function () {
	var $el = (0, _jquery2.default)(this);
	$el.closest('.dataTable').DataTable().row($el.closest('tr').get(0)).delete();
});

// lazy initialization when bootstrap tab is selected
(0, _jquery2.default)(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
	var $target = (0, _jquery2.default)(e.target);
	var target = $target.attr('data-target') || $target.attr('href');
	if (!target) {
		log('a[data-toggle="tab"] does NOT define data-target: %o', e.target);
		return;
	}
	var selector = target + ' [data-table]';
	(0, _jquery2.default)(selector).each(function () {
		var _this = this;

		setTimeout(function () {
			create(_this);
		}, 0);
	});
});

(0, _jquery2.default)(document).on('preInit.dt', function (e, settings) {
	var api = new _jquery2.default.fn.dataTable.Api(settings);

	// override logic of assigning rowId
	settings.rowIdFn = api.rowId;

	// insert second header row for filters
	if (api.init().columns.filter(function (c) {
		return c.searchable !== false;
	}).length > 0) {
		var $header = (0, _jquery2.default)(api.table().header());
		// $header.append(`<tr class="column-filters">${$header.find('tr:first th').toArray().map(() => `<th></th>`).join('')}</tr>`);
		// log('column-filters row added to table header');

		// render filters
		log('RENDERING COLUMN FILTERS');
		$header.find('tr.column-filters th').each(function (i, th) {
			api.columnByFilter(th).renderer().renderFilter();
		});

		// execute initializers for table header
		(0, _initialize.initialize)($header);
	}
});

(0, _jquery2.default)(document).on('column-visibility.dt', function (e, settings, column, visible) {
	log('Column ' + column + ' has changed to ' + (visible ? 'visible' : 'hidden'));
	var api = new _jquery2.default.fn.dataTable.Api(settings);
	if (visible) {
		api.column(column).renderer().renderFilter();
	}
});

function create(element) {
	var $target = (0, _jquery2.default)(element);

	if (!$target.is('table')) {
		log('[data-table] attribute is valid for table and div elements only!');
		return;
	}

	if ($target.data('data-table-created')) {
		return;
	}

	// check if data-table is inside bootstrap tab
	var $bsTab = $target.closest('.tab-pane');
	if ($bsTab.length > 0) {
		if (!$bsTab.is('.active')) {
			return;
		}
	}

	var opts = (0, _options2.default)(element);

	// if there is no explicit id attribute, set it to table name
	if (!$target.attr('id')) {
		$target.attr('id', opts.name);
	}

	// add empty footer when footerCallback is present in options. This callback is used to generate footer markup.
	if (opts.footerCallback) {
		$target.append('<tfoot></tfoot>');
	}

	// create basic header, titles and filters
	if (opts.columns.filter(function (c) {
		return c.searchable !== false;
	}).length > 0) {
		var titles = opts.columns.map(function (x) {
			return x.title;
		});
		var sumCells = opts.columns.filter(function (x) {
			return x.sum;
		}).length > 0 ? opts.columns.map(function (x) {
			return x.sum ? '<th>-</th>' : '<th></th>';
		}).join('') : '';
		var sumRows = sumCells ? '<tr class="column-sums" style="display:none;">' + sumCells + '</tr>' + ('<tr class="column-sums-error" style="display:none;"><th colspan="' + titles.length + '"></th></tr>') : '';
		opts.columns.forEach(function (c) {
			return delete c.title;
		});
		$target.append('<thead>\n\t\t\t\t<tr>' + titles.map(function (t) {
			return '<th class="column-titles">' + t + '</th>';
		}).join('') + '</tr>\n\t\t\t\t<tr class="column-filters">' + titles.map(function (t) {
			return '<th></th>';
		}).join('') + '</tr>\n\t\t\t\t' + sumRows + '\t\t\t\t\n\t\t\t</thead>');

		log('column-filters row added to table header');
	}

	var tableApi = $target.DataTable(opts);
	$target.data('data-table-created', true);

	// adding filter inputs
	//filter.register(tableApi);


	// selection support
	var selectedStoreId = $target.attr('data-table-selected');
	var $selected = selectedStoreId ? (0, _jquery2.default)('#' + selectedStoreId) : (0, _jquery2.default)();
	if ($selected.length > 0) {
		$target.on('click', 'tbody tr', function () {
			var $tr = (0, _jquery2.default)(this);
			if ($tr.hasClass('active')) {
				$tr.removeClass('active');
				$selected.val('');
			} else {
				if (!opts.multiSelect) {
					$target.find('tr.active').removeClass('active');
				}
				$tr.addClass('active');
				var id = $target.DataTable().row(this).id();
				$selected.val(id);
			}
		});
	}
	return tableApi;
}

exports.default = create;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/create.js
// module id = 484
// module chunks = 0